import {Input} from 'antd';
import React, {
    Dispatch, SetStateAction, FC, ReactElement,
} from 'react';

interface IDropdownRendererProps {
    inputValue: string;
    setInputValue: Dispatch<SetStateAction<string>>;
    menu: ReactElement;
}

export const SearchableDropdown: FC<IDropdownRendererProps> = ({
    menu,
    setInputValue,
    inputValue,
}: IDropdownRendererProps) => (

    <div className="select-dropdown-content">
        <Input
            className="select-dropdown-input"
            placeholder="Поиск"
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            // чтобы не удалять tags когда мы чистим этот input
            onKeyDown={event => {
                if (event.key === 'Backspace') {
                    event.stopPropagation();
                }
            }}
        />
        {menu}
    </div>
);
